<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Distribuições</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Acompanhe as ultimas distribuções
      </span>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListDistributions v-else :distributions="distributions" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ListDistributions from '@/components/distributions/ListDistributions.vue'

export default {
  name: 'DistributionsList',

  components: {
    LoadingData,
    ListDistributions,
  },

  data() {
    return {
      isLoadingData: true,
      distributions: [],
    }
  },

  methods: {
    async getDistributions() {
      try {
        this.distributions = await this.$store.dispatch('getDistributions')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getDistributions()
  },
}
</script>
